export const getPageTitle = pageItems => {
  return pageItems.filter(item => item).join(' ');
};
